import React from 'react'
import Layout from './../../../components/help/Layout/Layout'
import Seo from '../../../components/help/Seo'
import Header from '../../../components/ui/Header/Header'
import Intro from '../../../components/ui/Intro/Intro'
import Management from '../../../components/pages/Shareholders/Management/Management'
import { graphql, useStaticQuery } from 'gatsby'
import { getHrefToHome } from '../../../utils/getHrefToHome'
import Founders from '../../../components/pages/Shareholders/Management/Founders/Founders'
import Timeline from '../../../components/pages/Shareholders/Timeline/Timeline'
import Shares from '../../../components/pages/Shareholders/Shares/Shares'

const ShareholdersPage = () => {
    const lang = 'en'

    const hrefHome = getHrefToHome(lang)

    const result = useStaticQuery(graphql`
        {
            title: datoCmsRenshinPageShareholder(title: { eq: "Title" }, locale: { eq: "en" }) {
                value
            }

            text: datoCmsRenshinPageShareholder(title: { eq: "Text" }, locale: { eq: "en" }) {
                value
            }

            titleSmall: datoCmsRenshinPageShareholder(title: { eq: "Title small" }, locale: { eq: "en" }) {
                value
            }

            blockLeft: datoCmsRenshinPageShareholder(title: { eq: "Block left" }, locale: { eq: "en" }) {
                value
                photo {
                    alt
                    url
                }
                description
            }

            blockRight: datoCmsRenshinPageShareholder(title: { eq: "Block right" }, locale: { eq: "en" }) {
                value
                photo {
                    alt
                    url
                }
                description
            }

            experienceTitle: datoCmsRenshinPageShareholder(title: { eq: "Experience title" }, locale: { eq: "en" }) {
                value
            }

            timeline: datoCmsRenshinPageShareholder(title: { eq: "Timeline" }, locale: { eq: "en" }) {
                value
                photo {
                    alt
                    url
                }
            }
            
            shares: datoCmsRenshinPageShareholder(title: { eq: "Shares" }, locale: { eq: "en" }) {
                value
                photo {
                    alt
                    url
                }
            }

            slides: allDatoCmsRenshinDataInCircle(sort: { fields: sorting, order: ASC }, filter: { locale: { eq: "en" } }) {
                nodes {
                    name
                    logo {
                        url
                    }
                    link
                    linkOnFile {
                        url
                    }
                }
            }

            seo: datoCmsRenshinSeo(originalId: { eq: "114097348" }, locale: { eq: "en" }) {
                titleH1
                crumbsName
                bgDesktop {
                    url
                }
                bgTabletA {
                    url
                }
                bgTabletP {
                    url
                }

                bgMobile {
                    url
                }
                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(originalId: { eq: "114097337" }, locale: { eq: "en" }) {
                crumbsName
            }
        }
    `)

    const photo = {
        1920: result.seo.bgDesktop.url,
        1440: result.seo.bgDesktop.url,
        1024: result.seo.bgTabletA?.url,
        768: result.seo.bgTabletP?.url,
        360: result.seo.bgMobile?.url
    }

    const breadCrumbs = [
        { name: `${result.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${result.seo.crumbsName}`, current: true }
    ]

    return (
        <Layout lang={lang}>
            <Seo title={result.seo?.seo?.title} description={result.seo?.seo?.description} />
            <Header light lang={lang} />
            <Intro crumbs={breadCrumbs} title={`${result.seo.titleH1}`} photo={photo} lang={lang} />
            <Management data={result} lang={lang} />
            <Founders data={result} lang={lang} />
            <Timeline data={result} lang={lang} />
            {/*<Shares data={result} lang={lang} />*/}
        </Layout>
    )
}

export default ShareholdersPage
